import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <span className="font-display text-sm font-semibold text-brand-400">{index}</span>
      <span className="h-px w-12 bg-brand-500/50" />
      <span className="text-xs font-medium uppercase tracking-[0.3em] text-mist">{label}</span>
    </div>
  </Reveal>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className={`block will-change-transform ${innerClassName}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.05, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);
